import alt from '../alt';
import reportAction from '../actions/reportAction';

class reportStore {
    constructor() {
        this.bindActions(reportAction);
        this.processing = false;
        this.warningMsg = "";
        this.startYear = new Date().getFullYear();
        this.startMonth = new Date().getMonth();
        this.endYear = new Date().getFullYear();
        this.endMonth = new Date().getMonth();
        this.staffId = "";
        this.mcst = "";
        this.reportNo = '';
        this.reports = [];
        this.facility = "";
        this.contractors = "";
        this.isReportCreated = false;
        this.reportDetail = {};

    }

    onProcessing(data) {
        this.processing = data;
    }
    onUpdateSM(data) {
        this.startYear = data.startYear;
        this.startMonth = data.startMonth;
    }
    onUpdateEM(data) {
        this.endMonth = data.endMonth;
        this.endYear = data.endYear;
    }
    onUpdateUI(data) {
        this.staffId = data.staffId;
    }
    onUpdateCI(data) {
        this.mcst = data.mcst;
    }
    onUpdateRN(data) {
        this.reportNo = data.reportNo;
    }
    onShouldListShow(data) {
        this.reports[data].shouldListShow = !this.reports[data].shouldListShow;
    }
    onCloseListShow() {
        for (let i = 0; i < this.reports.length; i++) {
            this.reports[i].shouldListShow = false;
        }
    }
    onGetReportSuccess(data) {
        this.reports = data;
    }
    onGetReportByRNSuccess(data) {
        this.reports = data;
    }
    onFacility(data) {
        this.facility = data;
    }
    onContractors(data) {
        this.contractors = data;
    }
    onExtendIncidentSuccess(data) {
        if (this.reportDetail._id == data._id) {
            this.reportDetail.extend = data.extend;
            this.reportDetail.reportImage = data.reportImage;
            this.reportDetail.targetDate = data.targetDate;
        }
        let len = this.reports.length;
        for (let i = 0; i < len; i++) {
            if (this.reports[i]._id == data._id) {
                this.reports[i].extend = data.extend;
                this.reports[i].reportImage = data.reportImage;
                this.reports[i].targetDate = data.targetDate;
                break;
            }
        }
    }
    onResolveIncidentSuccess(data) {
        if (this.reportDetail._id == data._id) {
            this.reportDetail.resolution = data.resolution;
            this.reportDetail.resolvedBy = data.resolvedBy;
            this.reportDetail.status = 0;
            this.reportDetail.completionDate = data.completionDate;
            this.reportDetail.reportImage = data.reportImage;
        }
        let len = this.reports.length;
        for (let i = 0; i < len; i++) {
            if (this.reports[i]._id == data._id) {
                this.reports[i].resolution = data.resolution;
                this.reports[i].resolvedBy = data.resolvedBy;
                this.reports[i].completionDate = data.completionDate;
                this.reports[i].reportImage = data.reportImage;
                this.reports[i].status = 0;
                break;
            }
        }
    }
    onAddingRemarkSuccess(data) {
        if (this.reportDetail._id == data._id) {
            this.reportDetail.remarks = data.remarks;
            this.reportDetail.reportImage = data.reportImage;
        }
        let len = this.reports.length;
        for (let i = 0; i < len; i++) {
            if (this.reports[i]._id == data._id) {
                this.reports[i].remarks = data.remarks;
                this.reports[i].reportImage = data.reportImage;
                break;
            }
        }
    }
    onRemoveIncidentSuccess(data) {

        let len = this.reports.length;
        if (this.reportDetail._id == data._id) {
            this.reportDetail.status = 2;
            this.reportDetail.resolution = data.resolution;
            this.reportDetail.resolvedBy = data.resolvedBy;
        }
        for (let i = 0; i < len; i++) {
            if (this.reports[i]._id == data._id) {
                this.reports[i].status = 2;
                this.reports[i].resolution = data.resolution;
                this.reports[i].resolvedBy = data.resolvedBy;
                break;
            }
        }
    }

    // to be verified
    onGetDetailSuccess(data) {
        this.reportDetail = data;
    }
    onIsReportCreated(data) {
        this.isReportCreated = data;
    }

}
export default alt.createStore(reportStore, 'reportStore');


// WEBPACK FOOTER //
// ./app/stores/reportStore.js